import { ApiResponse, TokenData, IPhysicalLocation } from '../models';
import * as http from './http';
import ApiService from './service';

export class PhysicalLocationService extends ApiService {
  public async loadAllPhysicalLocations(): Promise<IPhysicalLocation[]> {
    const url = `${this.apiDomain}/api/trade-in/physical-location`;

    const resposne = await http.get<ApiResponse<IPhysicalLocation[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updatePhysicalLocation(data: IPhysicalLocation, id?: string) {
    const url = `${this.apiDomain}/api/trade-in/physical-location/${id}`;

    const response = await http.put<ApiResponse<IPhysicalLocation>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createPhysicalLocation(data: IPhysicalLocation) {
    const url = `${this.apiDomain}/api/trade-in/physical-location`;

    const response = await http.post<ApiResponse<IPhysicalLocation>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deletePhysicalLocation(id?: string) {
    const url = `${this.apiDomain}/api/trade-in/physical-location/${id}`;

    const response = await http.remove<ApiResponse<IPhysicalLocation>>(
      url,
      this.store
    );
    return response.data;
  }
}
